import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { UsersAvatarsCategoryItem } from '../../types/users-avatars-category.types';
import { getAvatarColor, getAvatarInitials } from '../../../utils/avatar';
import {
  ApiRequestBuilder,
  ApiRequestStandardResponse,
  ApiService,
} from '../../../api';
import { cloneDeep } from 'lodash';
import { EntityMSUserInfos } from '../../../../../../backend-core-lib/app/common-shared/account/models';

@Component({
  selector: 'users-avatars-category',
  templateUrl: './users-avatars-category.component.html',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class UsersAvatarsCategoryComponent implements OnChanges {
  @HostBinding('class')
  readonly cssClass = 'users-avatars-category';

  @Input() items: UsersAvatarsCategoryItem[] = [
    /*{
      id: 'b05e7ea2-ea39-4739-abe3-d959142ee950',
      displayName: 'Fabian Ackeret',
      email: 'fabian.ackeret@anyshare.onmicrosoft.com',
      type: 'User',
      tenantId: '533d84e6-ff3b-4a32-846c-76cf615c71a4',
      userPrincipalName: 'fabian.ackeret@anyshare.onmicrosoft.com',
    },
    {
      id: 'b05e7ea2-ea39-4739-abe3-d959142ee951',
      displayName: 'Matthias Ackeret',
      email: 'matthias.ackeret@anyshare.onmicrosoft.com',
      type: 'User',
      tenantId: '533d84e6-ff3b-4a32-846c-76cf615c71a4',
      userPrincipalName: 'matthias.ackeret@anyshare.onmicrosoft.com',
    },
    {
      id: 'b05e7ea2-ea39-4739-abe3-d959142ee952',
      displayName: 'Yon Sebal',
      email: 'yon.sebal@anyshare.onmicrosoft.com',
      type: 'User',
      tenantId: '533d84e6-ff3b-4a32-846c-76cf615c71a4',
      userPrincipalName: 'yon.sebal@anyshare.onmicrosoft.com',
    },
    {
      id: 'b05e7ea2-ea39-4739-abe3-d959142ee953',
      displayName: 'Max Mustermann',
      email: 'max.mustermann@anyshare.onmicrosoft.com',
      type: 'User',
      tenantId: '533d84e6-ff3b-4a32-846c-76cf615c71a4',
      userPrincipalName: 'max.mustermann@anyshare.onmicrosoft.com',
    },*/
  ];
  @Input() maxDisplay = 3;
  @Input() multipleAllowed = true;
  @Input() showChange = true;
  @Input() title = '';
  @Input() allUsersResponse = false; // it will emit allUsersChange as well
  // EntityMSUserInfos

  @Input() entityType = 'ENVIRONMENT'; // 'ENVIRONMENT' , 'APP', 'FLOW';
  @Input() entityUid = '';
  @Input() environmentUid = '';
  @Input() userType = 'owner'; // 'owner' | 'deputies' | 'shared';

  @Input()
  availableUsers: UsersAvatarsCategoryItem[] | undefined = undefined;

  @Output() itemsChange = new EventEmitter<UsersAvatarsCategoryItem[]>();
  @Output() allUsersChange = new EventEmitter<EntityMSUserInfos>();
  @Output() availableUsersFetch = new EventEmitter<void>();

  selectedUser?: UsersAvatarsCategoryItem;

  searchValue = '';
  constructor(private apiService: ApiService) {}

  ngOnChanges() {}

  getUserAvatarInitials(fullname?: string, email?: string): string {
    const fullNameSplited = (fullname || '').split(' ');
    return getAvatarInitials(
      fullNameSplited.length >= 1 && fullNameSplited[0].length >= 1
        ? fullNameSplited[0].charAt(0)
        : undefined,
      fullNameSplited.length >= 2 && fullNameSplited[1].length >= 1
        ? fullNameSplited[1].charAt(0)
        : undefined,
      email,
    );
  }
  getUserAvatarColor(fullname?: string, email?: string): string {
    return getAvatarColor(fullname, '', email);
  }

  getAvatarTooltip(item: UsersAvatarsCategoryItem): string {
    const email = item.email || item.userPrincipalName;
    return email ? `${item.displayName} <${email}>` : `${item.displayName}`;
  }

  async onChangeUsers(): Promise<void> {
    console.log('onChangeUsers');
    this.availableUsersFetch.emit();
  }
  async onDeleteUser(item: UsersAvatarsCategoryItem): Promise<void> {
    const userToAdd = cloneDeep(item);
    this.selectedUser = undefined;
    const modifyUserRequest = new ApiRequestBuilder('deleteEnvironmentUser')
      .replaceUrl({
        environmentUid: this.environmentUid,
        entityType: this.entityType,
        entityId: this.entityUid,
        userType: this.userType,
        userId: userToAdd.id,
      })
      .build();
    const resultApi = await this.apiService.callApi(modifyUserRequest);
    if (!resultApi || resultApi.status === 'error') {
      return resultApi.data || 'ServerUnreachable';
    }

    this.processUpdateResultApi(resultApi);
  }

  processUpdateResultApi(resultApi: ApiRequestStandardResponse): void {
    if (!this.allUsersResponse) {
      this.items = resultApi.data;
    } else {
      this.items = resultApi.data[this.userType];
      if (this.userType === 'owner' && this.items) {
        this.items = [resultApi.data[this.userType]];
      } else {
        this.items = resultApi.data[this.userType];
      }
      this.items = this.items || [];
      this.allUsersChange.emit(resultApi.data);
    }
    this.itemsChange.emit(this.items);
  }
  async onAddUser(): Promise<void> {
    if (!this.selectedUser) {
      return;
    }
    const userToAdd = cloneDeep(this.selectedUser);
    this.selectedUser = undefined;
    const modifyUserRequest = new ApiRequestBuilder('addEnvironmentUser')
      .replaceUrl({
        environmentUid: this.environmentUid,
        entityType: this.entityType,
        entityId: this.entityUid,
        userType: this.userType,
        userId: userToAdd.id,
      })
      .build();
    const resultApi = await this.apiService.callApi(modifyUserRequest);
    if (!resultApi || resultApi.status === 'error') {
      return resultApi.data || 'ServerUnreachable';
    }

    this.processUpdateResultApi(resultApi);
  }
}
